export const environment = {
    production: true,
    defaultUrl: '/adm/user/Default.aspx',
    userInfoUrl: '/adm/user/UserContact.aspx',
    accessDeniedUrl: '/AccessDenied.aspx/AccessDenied.aspx',
    defaultLocale: 'ru',
};
